import type { AgentTeamMembershipInfoItem } from './type';

/** 按接口会员等级从 membership_infos 中解析展示名称，调用方只提供当前 level。 */
export function getAgentTeamMembershipNameByLevel(
  level?: number,
  membershipInfos?: AgentTeamMembershipInfoItem[],
): string | undefined {
  const matchedMembershipInfo = membershipInfos?.find((item) => (
    Number(item.level) === Number(level)
  ));
  return matchedMembershipInfo?.member_name;
}
